<script setup>
/* eslint-disable no-unused-vars */
/* global defineProps, defineEmits */
import moment from "moment/moment";

import { onMounted, ref } from "vue";


const props = defineProps({
  dns: {
    type: Array,
    default: () => []
  }
});

const sortType = ref('');

const dnsModel = ref(null);

function formatDateTime(value) {
  if (value) {
    return moment(String(value)).format('DD/MM/YYYY HH:mm');
  }
}

function sortBy(column) {
  if (sortType.value === '') {
    sortType.value = 'ASC';
  } else if (sortType.value === 'ASC') {
    sortType.value = 'DESC';
  } else if (sortType.value === 'DESC') {
    sortType.value = '';
  }
  sortTableData(column);
}

function sortTableData(column) {
  dnsModel.value.sort((a, b) => {
    const valueA = a[column];
    const valueB = b[column];
    if (sortType.value === 'ASC') {
      return valueA.localeCompare(valueB);
    } else if (sortType.value === 'DESC') {
      return valueB.localeCompare(valueA);
    }
    return 0;
  });
}

onMounted(() => {
  // console.log('mounted DNSDataTable', this.dns);
});
</script>

<template>
  <div>
    <el-row
      v-if="dns.length>0"
      class="px-4"
    >
      <el-col
        v-if="dns.length>0"
        :span="24"
      >
        <div class="table table-dns table-not-mobile pt-0 px-4">
          <table>
            <thead>
              <tr>
                <th>
                  <div class="d-flex justify-content-start">
                    <!--                <div class="d-flex justify-content-start" @click="sortBy('type')">-->
                    <span class="mt-1">TIPO
                      <!--                    <font-awesome-icon v-if="sortType === 'ASC'" icon="sort-alpha-up"></font-awesome-icon>-->
                      <!--                    <font-awesome-icon v-else-if="sortType === 'DESC'" icon="sort-alpha-down"></font-awesome-icon>-->
                      <!--                    <font-awesome-icon v-else icon="sort"></font-awesome-icon>-->
                    </span>
                  </div>
                </th>
                <th>
                  <div class="d-flex justify-content-start">
                    <span class="mt-1">
                      VALOR
                    </span>
                  </div>
                </th>
                <th>
                  <div class="d-flex justify-content-start">
                    <span class="mt-1">
                      IP
                    </span>
                  </div>
                </th>
                <th>
                  <div class="d-flex justify-content-start">
                    <span class="mt-1">
                      TTL
                    </span>
                  </div>
                </th>
                <th>
                  <div class="d-flex justify-content-start">
                    <span class="mt-1">
                      FECHA INICIO
                    </span>
                  </div>
                </th>
                <th>
                  <div class="d-flex justify-content-start">
                    <span class="mt-1">
                      FECHA FIN
                    </span>
                  </div>
                </th>
                <th>
                  <div class="d-flex justify-content-start">
                    <span class="mt-1">
                      ACTUALIZADO
                    </span>
                  </div>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="aDNS in dns"
                :key="aDNS.id"
              >
                <td>
                  <div class="d-flex align-items-center">
                    <span class="ml-2">{{ aDNS.type }}</span>
                  </div>
                </td>
                <td>
                  <div class="d-flex align-items-center">
                    <span class="ml-2">{{ aDNS.value }}</span>
                  </div>
                </td>
                <td>
                  <div class="d-flex align-items-center">
                    <span class="ml-2">{{ aDNS.ip }}</span>
                  </div>
                </td>
                <td>
                  <div class="d-flex align-items-center">
                    <span class="ml-2">{{ aDNS.ttl }}</span>
                  </div>
                </td>
                <td>
                  <div class="d-flex align-items-center">
                    <span class="ml-2">{{ formatDateTime(aDNS.dateStart) }}</span>
                  </div>
                </td>
                <td>
                  <div class="d-flex align-items-center">
                    <span class="ml-2">{{ formatDateTime(aDNS.dateEnd) }}</span>
                  </div>
                </td>
                <td>
                  <div class="d-flex align-items-center">
                    <span class="ml-2">{{ formatDateTime(aDNS.lastUpdate) }}</span>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="table-mobile px-2">
          <el-row
            v-for="aDNS in dns"
            :key="aDNS.id"
            class="mt-2"
          >
            <el-card class="dns-mobile-card w-100">
              <div class="dns-mobile-card__item">
                <span class="dns-mobile-card__label">Tipo:</span>
                <span>{{ aDNS.type || '--' }}</span>
              </div>
              <div class="dns-mobile-card__item">
                <span class="dns-mobile-card__label">Valor:</span>
                <span>{{ aDNS.value || '--' }}</span>
              </div>
              <div class="dns-mobile-card__item">
                <span class="dns-mobile-card__label">IP:</span>
                <span>{{ aDNS.ip || '--' }}</span>
              </div>
              <div class="dns-mobile-card__item">
                <span class="dns-mobile-card__label">TTL:</span>
                <span>{{ aDNS.ttl || '--' }}</span>
              </div>
              <div class="dns-mobile-card__item">
                <span class="dns-mobile-card__label">Fecha inicio:</span>
                <span>{{ formatDateTime(aDNS.dateStart) || '--' }}</span>
              </div>
              <div class="dns-mobile-card__item">
                <span class="dns-mobile-card__label">Fecha fin:</span>
                <span>{{ formatDateTime(aDNS.dateEnd) || '--' }}</span>
              </div>
              <div class="dns-mobile-card__item">
                <span class="dns-mobile-card__label">Actualizado:</span>
                <span>{{ formatDateTime(aDNS.lastUpdate) || '--' }}</span>
              </div>
            </el-card>
          </el-row>
        </div>
      </el-col>
    </el-row>
    <el-row v-else>
      <el-col :span="24">
        <div class="d-flex justify-content-center">
          <span
            class="mt-2"
            style="font-weight: bolder; font-size: 0.9em"
          >NO HAY DATOS</span>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<style scoped lang="scss">

.table-dns {
  table {
    thead {
      tr {
        th {
          padding: 0px !important;
          margin: 0px !important;
        }
      }
    }

    tbody {
      td {
        letter-spacing: -0.05em;

        font-weight: bolder;

        letter-spacing: -0.05em;
        font-size: 0.9em;

        .link-name {
          margin: auto;
          margin-left: 10px;
        }
      }
    }
  }
}

.table-mobile {
  display: none;
}

.dns-mobile-card {
  border-radius: 18px;
}

.dns-mobile-card :deep(.el-card__body) {
  padding: 16px 16px 18px;
}

.dns-mobile-card__item {
  display: flex;
  flex-direction: column;
  gap: 3px;
  margin-bottom: 10px;
  word-break: break-word;
}

.dns-mobile-card__item:last-child {
  margin-bottom: 0;
}

.dns-mobile-card__label {
  color: $bg-blue;
  font-weight: 800;
}

@media (min-width: 768px) {
  .table-mobile {
    display: none;
  }
}

@media (max-width: 767px) {
  .table-not-mobile {
    display: none;
  }

  .table-mobile {
    display: block;
    padding-right: 0;
    padding-left: 0;
  }
}
</style>
